export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-rounded-corners.88d2546b.webp";